import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";
import { WHATSAPP_URL } from "../constants/site";

export default function HomePage() {
  return (
    <>
      <section className="relative overflow-hidden pt-16 pb-20 md:pt-20 md:pb-32 page-x max-w-max-width mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="z-10">
            <span className="inline-block px-4 py-1 rounded-full bg-primary-fixed text-on-primary-fixed font-label-md mb-6">
              World-Class Online Academy
            </span>
            <h1 className="text-display-responsive text-primary mb-6 leading-tight">
              Begin Your Quran Learning Journey Online
            </h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant mb-10 max-w-lg">
              Experience personalized live 1:1 classes with certified scholars.
              Flexible scheduling for kids and adults in a safe, interactive
              environment.
            </p>
            <div className="flex flex-col xs:flex-row flex-wrap gap-3 sm:gap-4">
              <Link
                to="/contact"
                className="bg-tertiary-container text-on-tertiary-container px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center font-label-md font-bold shadow-lg hover:shadow-xl transition-all"
              >
                Book Free Trial
              </Link>
              <Link
                to="/programs"
                className="px-6 sm:px-8 py-3 sm:py-4 rounded-full w-full sm:w-auto text-center border-2 border-primary text-primary font-label-md font-bold hover:bg-primary-container hover:text-on-primary-container transition-all"
              >
                Explore Programs
              </Link>
            </div>
          </div>
          <div className="relative flex justify-center items-center">
            <div className="absolute w-[120%] h-[120%] celestial-gradient opacity-40 rounded-full blur-3xl"></div>
            <div className="hero-orb relative w-full aspect-square max-w-md rounded-full bg-white shadow-2xl border-4 border-primary-fixed flex items-center justify-center overflow-hidden">
              <img
                alt="Online Quran learning with celestial patterns"
                className="w-full h-full object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuAr4Gu6IrHoQs7LrA3oMLorI1FWn09xSFpx0rEmq5gdEQSC2pCPB-w8zQK6tgwN_0766WyKgplGRUkVKgo8NTXJkcMriZqCbKdoyJ91rtMqpCEUmKivvq5OUtDSNFEhbuBRfefbs00npAXloFv-TRWNlEv3ZSgYG6ty33wnwAplbpQCe-W7qQoalMKGKj_u9m3m6eVh5auIJuiNfJ6y4RPm00MyLMs96yQF0iKjwHiXBzsIvP-6vlkYpIHO3Xj30oFjs7fPK58PNJet"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-surface-container-low py-12 page-x">
        <div className="max-w-max-width mx-auto flex flex-wrap justify-center md:justify-between gap-8 opacity-80">
          <div className="flex items-center gap-3">
            <Icon
              name="record_voice_over"
              className="material-symbols-outlined text-primary"
            />
            <span className="font-label-md font-bold text-on-surface-variant">
              Live One-on-One Classes
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Icon
              name="schedule"
              className="material-symbols-outlined text-primary"
            />
            <span className="font-label-md font-bold text-on-surface-variant">
              Flexible 24/7 Scheduling
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Icon
              name="verified_user"
              className="material-symbols-outlined text-primary"
            />
            <span className="font-label-md font-bold text-on-surface-variant">
              Certified Male &amp; Female Tutors
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Icon
              name="family_restroom"
              className="material-symbols-outlined text-primary"
            />
            <span className="font-label-md font-bold text-on-surface-variant">
              Safe &amp; Secure Environment
            </span>
          </div>
        </div>
      </section>

      <section className="section-y page-x max-w-max-width mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-headline-responsive text-primary mb-4">
            Choose Your Learning Path
          </h2>
          <div className="w-24 h-1 bg-tertiary-fixed mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-gutter">
          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-tertiary-fixed">
            <div className="w-12 h-12 bg-primary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="child_care"
                className="material-symbols-outlined text-primary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Beginners
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Perfect for those starting from zero. Learn letters and
              pronunciation with patience.
            </p>
            <Link
              to="/programs/noorani-qaida"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Get Started{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>

          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-primary-fixed">
            <div className="w-12 h-12 bg-secondary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="toys"
                className="material-symbols-outlined text-secondary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Kids
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Engaging and fun lessons designed to keep children motivated and
              excited.
            </p>
            <Link
              to="/contact"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Explore More{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>

          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-tertiary-fixed">
            <div className="w-12 h-12 bg-primary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="person"
                className="material-symbols-outlined text-primary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Adults
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Customized pacing for busy professionals and life-long learners.
            </p>
            <Link
              to="/contact"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Join Now{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>

          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-primary-fixed">
            <div className="w-12 h-12 bg-secondary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="memory"
                className="material-symbols-outlined text-secondary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Hifz
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Memorize the Holy Quran with expert guidance and revision
              techniques.
            </p>
            <Link
              to="/programs/hifz"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Start Hifz{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>

          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-tertiary-fixed">
            <div className="w-12 h-12 bg-primary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="audiotrack"
                className="material-symbols-outlined text-primary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Tajweed
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Master the rules of recitation to beautify your Quran reading.
            </p>
            <Link
              to="/contact"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Learn Rules{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>

          <div className="bg-white card-pad rounded-2xl border border-outline-variant shadow-sm hover:shadow-md transition-all group border-t-4 border-t-primary-fixed">
            <div className="w-12 h-12 bg-secondary-fixed rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <Icon
                name="menu_book"
                className="material-symbols-outlined text-secondary"
              />
            </div>
            <h3 className="font-headline-md text-headline-md text-primary mb-3">
              Understanding
            </h3>
            <p className="font-body-md text-on-surface-variant mb-6">
              Translation and Tafseer classes to grasp the depth of Allah's
              word.
            </p>
            <Link
              to="/contact"
              className="text-primary font-label-md flex items-center gap-2 group-hover:translate-x-2 transition-transform"
            >
              Deep Dive{" "}
              <Icon
                name="arrow_forward"
                className="material-symbols-outlined text-[18px]"
              />
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-surface-container-highest section-y page-x">
        <div className="max-w-max-width mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-end mb-10 md:mb-16 gap-8">
            <div className="max-w-2xl">
              <h2 className="text-headline-responsive text-primary mb-4">
                Why Families Choose Online Quran Universe
              </h2>
              <p className="font-body-lg text-on-surface-variant">
                We combine traditional values with modern educational techniques
                to provide the best possible experience for your loved ones.
              </p>
            </div>
            <Link
              to="/academy"
              className="bg-primary text-on-primary px-8 py-3 rounded-full font-label-md"
            >
              Learn Our Story
            </Link>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="verified"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Verified Tutors
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  All our teachers go through a rigorous screening and
                  background check.
                </p>
              </div>
            </div>
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="video_chat"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Interactive Software
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  Digital whiteboards and screen sharing make learning active
                  and visual.
                </p>
              </div>
            </div>
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="trending_up"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Progress Tracking
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  Detailed monthly reports and parent portals to monitor
                  success.
                </p>
              </div>
            </div>
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="support_agent"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Dedicated Support
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  A student coordinator assigned to every family for any
                  assistance.
                </p>
              </div>
            </div>
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="payments"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Affordable Pricing
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  Competitive rates with family discounts and trial classes.
                </p>
              </div>
            </div>
            <div className="flex gap-6 p-6 bg-surface rounded-2xl shadow-sm border border-outline-variant">
              <div className="shrink-0 w-12 h-12 bg-primary-fixed rounded-xl flex items-center justify-center">
                <Icon
                  name="language"
                  className="material-symbols-outlined text-primary"
                />
              </div>
              <div>
                <h4 className="font-headline-md text-headline-md text-primary text-[18px] mb-2">
                  Global Community
                </h4>
                <p className="font-body-md text-on-surface-variant">
                  Join thousands of students from USA, UK, Canada, and beyond.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y page-x max-w-max-width mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-headline-responsive text-primary mb-4">
            Our Quran Learning Programs
          </h2>
          <p className="font-body-lg text-on-surface-variant max-w-2xl mx-auto">
            From fundamental Arabic reading to advanced spiritual studies, find
            the perfect curriculum.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-gutter">
          <div className="group relative bg-white rounded-3xl overflow-hidden border border-outline-variant shadow-sm hover:shadow-xl transition-all">
            <div className="h-48 overflow-hidden">
              <img
                alt="Noorani Qaida book"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuC3opEiZqlN8CnsnfgQPEzjAJsSMUx0Sp6sgB-3id30t-0p1OQ43iRCpXm9ebxvF19rbLb-SaGRQWq6DzIUHmZ89XO6mdmEOL0vY999UQevMAUWAsZsjvu2b5PaGRirMVErPTgqFG7pG4nFDEDI8T6zxPQtSJ4u25XveKgR9c5MVkgVeO4z0qax3I7tUbbwrLllfLkTZRe3YOwvEkkL8s06WQ0d1wXw09ai4036BAkRTj5ZiQIwqnmwIVnLClA1SMqblwLguIbSXZup"
              />
            </div>
            <div className="p-6">
              <h4 className="font-headline-md text-headline-md text-primary mb-2">
                Noorani Qaida
              </h4>
              <p className="font-body-md text-on-surface-variant mb-6">
                The foundation of Arabic reading for children and beginners.
              </p>
              <Link
                to="/programs/noorani-qaida"
                className="block w-full text-center py-2 rounded-full border border-primary text-primary font-label-md hover:bg-primary hover:text-on-primary transition-all"
              >
                View Program
              </Link>
            </div>
          </div>

          <div className="group relative bg-white rounded-3xl overflow-hidden border border-outline-variant shadow-sm hover:shadow-xl transition-all">
            <div className="h-48 overflow-hidden">
              <img
                alt="Quran reading practice"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuBAW88qPCvKDnvK4_0gfjjJ4Lr-5m-jp6DHO4N3vCeyzLkDjAYr_x_asxmChWNJL_H0yUJzKRpIM6Qe7kdhsnnnzQNg5aKJw2c7ozfqCxAXSP4zQFtU2igSwcuqOTGR2xOkJucdKrCgZBPsjJjJqC17MMjrX399uOIsGYePmZ7MsEcf6cKZ5JLiwZztkK19SZG3VpZ-agFyQB8_eMESByKXCDxysH9oRQExJzfeRze0oKzPs1GLYBr3bd3-YpX1GAexjNkXuGwsmE40"
              />
            </div>
            <div className="p-6">
              <h4 className="font-headline-md text-headline-md text-primary mb-2">
                Quran Reading
              </h4>
              <p className="font-body-md text-on-surface-variant mb-6">
                Fluent recitation of the Holy Quran with proper flow.
              </p>
              <Link
                to="/programs"
                className="block w-full text-center py-2 rounded-full border border-primary text-primary font-label-md hover:bg-primary hover:text-on-primary transition-all"
              >
                View Program
              </Link>
            </div>
          </div>

          <div className="group relative bg-white rounded-3xl overflow-hidden border border-outline-variant shadow-sm hover:shadow-xl transition-all">
            <div className="h-48 overflow-hidden">
              <img
                alt="Tajweed recitation"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuAdaVri40HWOso8yErtigk_6noXXVOob818cEejrofexOjk3f7uwA8M_hbvfd-zhdZbS8Fo60EkBeHt7DwVX-TtNQWCF4kzUCqMcVb7JINClATSh-3tLkd8m916LlvxA_ePY39II4zP8UcwmNTP0iI4YDzMxYgbRlm90uYMRhZ-UiPSsQTYKifNotBM9Lp6qAEMe66euS7e4fqs172YJcE7zFlJYGO5SN6Hx8drwzVJsEiRkpJjTTS_cT_sXsSyKyaQmZ7NwCM2g-fD"
              />
            </div>
            <div className="p-6">
              <h4 className="font-headline-md text-headline-md text-primary mb-2">
                Tajweed Rules
              </h4>
              <p className="font-body-md text-on-surface-variant mb-6">
                Articulate every letter from its proper origin point.
              </p>
              <Link
                to="/programs"
                className="block w-full text-center py-2 rounded-full border border-primary text-primary font-label-md hover:bg-primary hover:text-on-primary transition-all"
              >
                View Program
              </Link>
            </div>
          </div>

          <div className="group relative bg-white rounded-3xl overflow-hidden border border-outline-variant shadow-sm hover:shadow-xl transition-all">
            <div className="h-48 overflow-hidden">
              <img
                alt="Islamic studies classroom"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuAYTjBkBSyfblir_3wDnG7pkvQRSRGLzT8ZmSY3JWF5ldbs_IJrBNGukstCisEatASD4YUQNQfO5T09BzZ80PUC88Et5BfvaIMBFFHIJexVtixHtMa2aAAL9vesRcpHeGK60FaCCvZPi_e6hKzXBEQF6iF_4QYNLEjxZDVn9jJ4s9h8M7zJHmwF_RhI4vBZaYfmfQlMghbN3iN3FWupNvrjgLJNqfQM_liWiMpJv2MJlPsjKaag2MxVSqL4ddZfiw_-qLlvZbFG1nKE"
              />
            </div>
            <div className="p-6">
              <h4 className="font-headline-md text-headline-md text-primary mb-2">
                Islamic Studies
              </h4>
              <p className="font-body-md text-on-surface-variant mb-6">
                Learn Hadith, Fiqh, and Seerah for a holistic life.
              </p>
              <Link
                to="/programs"
                className="block w-full text-center py-2 rounded-full border border-primary text-primary font-label-md hover:bg-primary hover:text-on-primary transition-all"
              >
                View Program
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-primary text-on-primary page-x overflow-hidden">
        <div className="max-w-max-width mx-auto">
          <div className="text-center mb-10 md:mb-16">
            <h2 className="text-headline-responsive mb-4 text-primary-fixed">
              How Online Classes Work
            </h2>
            <p className="font-body-lg text-primary-fixed opacity-80">
              Simple steps to start your spiritual journey from home.
            </p>
          </div>
          <div className="relative flex flex-col md:flex-row justify-between items-center md:items-start gap-12 md:gap-0">
            <div className="hidden md:block absolute top-12 left-0 w-full h-[2px] bg-primary-fixed-dim/30 z-0"></div>

            <div className="relative z-10 flex flex-col items-center text-center md:w-1/5 group">
              <div className="w-24 h-24 bg-primary-fixed text-primary rounded-full flex items-center justify-center mb-6 border-4 border-primary shadow-xl group-hover:scale-110 transition-transform">
                <Icon
                  name="event_available"
                  className="material-symbols-outlined text-4xl"
                />
              </div>
              <h5 className="font-headline-md text-headline-md text-[18px] mb-2">
                Book
              </h5>
              <p className="font-caption px-4 opacity-80">
                Request your free trial via the website.
              </p>
            </div>

            <div className="relative z-10 flex flex-col items-center text-center md:w-1/5 group">
              <div className="w-24 h-24 bg-primary-fixed text-primary rounded-full flex items-center justify-center mb-6 border-4 border-primary shadow-xl group-hover:scale-110 transition-transform">
                <Icon
                  name="tune"
                  className="material-symbols-outlined text-4xl"
                />
              </div>
              <h5 className="font-headline-md text-headline-md text-[18px] mb-2">
                Choose
              </h5>
              <p className="font-caption px-4 opacity-80">
                Pick your course and preferred teacher.
              </p>
            </div>

            <div className="relative z-10 flex flex-col items-center text-center md:w-1/5 group">
              <div className="w-24 h-24 bg-primary-fixed text-primary rounded-full flex items-center justify-center mb-6 border-4 border-primary shadow-xl group-hover:scale-110 transition-transform">
                <Icon
                  name="alarm"
                  className="material-symbols-outlined text-4xl"
                />
              </div>
              <h5 className="font-headline-md text-headline-md text-[18px] mb-2">
                Timing
              </h5>
              <p className="font-caption px-4 opacity-80">
                Set a schedule that fits your busy lifestyle.
              </p>
            </div>

            <div className="relative z-10 flex flex-col items-center text-center md:w-1/5 group">
              <div className="w-24 h-24 bg-primary-fixed text-primary rounded-full flex items-center justify-center mb-6 border-4 border-primary shadow-xl group-hover:scale-110 transition-transform">
                <Icon
                  name="videocam"
                  className="material-symbols-outlined text-4xl"
                />
              </div>
              <h5 className="font-headline-md text-headline-md text-[18px] mb-2">
                Meet
              </h5>
              <p className="font-caption px-4 opacity-80">
                Join the live class on our secure platform.
              </p>
            </div>

            <div className="relative z-10 flex flex-col items-center text-center md:w-1/5 group">
              <div className="w-24 h-24 bg-primary-fixed text-primary rounded-full flex items-center justify-center mb-6 border-4 border-primary shadow-xl group-hover:scale-110 transition-transform">
                <Icon
                  name="analytics"
                  className="material-symbols-outlined text-4xl"
                />
              </div>
              <h5 className="font-headline-md text-headline-md text-[18px] mb-2">
                Track
              </h5>
              <p className="font-caption px-4 opacity-80">
                Monitor progress via the parent dashboard.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-32 page-x max-w-max-width mx-auto">
        <div className="bg-surface-container-low rounded-section overflow-hidden flex flex-col lg:flex-row items-center border border-outline-variant">
          <div className="lg:w-1/2 p-12 lg:p-20">
            <h2 className="text-display-responsive text-primary mb-6">
              Start Learning from Anywhere
            </h2>
            <p className="font-body-lg text-on-surface-variant mb-10">
              Our reach is truly global. We bridge the distance between expert
              scholarship and your home, no matter where you are on the map.
            </p>
            <div className="grid grid-cols-2 gap-8 mb-10">
              <div>
                <div className="text-4xl font-bold text-primary mb-2">500+</div>
                <div className="font-label-md text-on-surface-variant">
                  Expert Tutors
                </div>
              </div>
              <div>
                <div className="text-4xl font-bold text-primary mb-2">10k+</div>
                <div className="font-label-md text-on-surface-variant">
                  Active Students
                </div>
              </div>
            </div>
            <Link
              to="/contact"
              className="inline-block bg-tertiary-container text-on-tertiary-container px-10 py-4 rounded-full font-label-md font-bold hover:shadow-lg transition-all"
            >
              Enroll Now
            </Link>
          </div>
          <div className="lg:w-1/2 w-full h-64 sm:h-80 md:h-[500px] bg-primary-container relative">
            <div className="w-full h-full opacity-60">
              <img
                alt="Global student network map"
                className="w-full h-full object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuCslcsP_CamIlcHI20N6Koth_43uvfX0WeQXsrVCnETavN5Tg2-xD2_-DDRI9iPw02n3o5poJhIk-DYu67kzfld361fgvWA4yOFxsSS7VReHV0jMY9OPI9s3TRejiR6NXYa54ZY9yuWNpmMm3ubZjpwNUxt_MgenQqjNVzYHq-zdCgTtrozUp5ZGDLwBnJqKGNiMl9hSbDjNpIXysI3NG6Z8eU6B6uJ88bBo6R7uBN6xN_-fozL6Sho8C375P6cmNUmyjw7lypMrdvM"
              />
            </div>
            <div className="absolute inset-0 flex items-center justify-center p-8">
              <div className="glass-card p-6 rounded-2xl max-w-xs text-center border-none shadow-2xl">
                <Icon
                  name="public"
                  className="material-symbols-outlined text-primary text-5xl mb-4"
                />
                <h4 className="font-headline-md text-primary mb-2">
                  Connecting Hearts
                </h4>
                <p className="font-caption text-on-surface-variant">
                  Bringing the light of the Quran to families across 50+
                  countries.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-y bg-pattern-islamic page-x">
        <div className="max-w-max-width mx-auto flex flex-col md:flex-row items-center gap-20">
          <div className="md:w-1/2">
            <img
              alt="Parent and child learning Quran together"
              className="rounded-[2.5rem] shadow-2xl border-4 md:border-8 border-white"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuAvE1DWORR14rOC7SQaBGPiMbbm30B3zNXV5jZ5dnSuMwrMnIUJUq1dBlFU-vA4ixLpBxkZvrB1O0MUE6RgBZ2eqql6rdk9S_1cXSbayu9q4AVYVI5BL5l-rQ_VuFKbQz7BFu7XwPw1kdUbOJUvqgguH71A4pE-DmeTOuuNZ77XujQkH2x71mZLW1Qlu_kAo9WHLlvW_mq57KHObDJmbUOywsajoBr9kt9SlKulWMJPIipqZbN00k8Z9wD9MJpIvoe-RHDO3SIZybcD"
            />
          </div>
          <div className="md:w-1/2">
            <h2 className="text-headline-responsive text-primary mb-8">
              Parent Confidence &amp; Safety
            </h2>
            <ul className="space-y-6">
              <li className="flex gap-4">
                <Icon
                  name="check_circle"
                  className="material-symbols-outlined text-primary font-bold"
                />
                <div>
                  <h5 className="font-label-md font-bold text-primary uppercase tracking-wider">
                    Regular Updates
                  </h5>
                  <p className="font-body-md text-on-surface-variant">
                    Receive weekly progress snapshots and monthly performance
                    calls.
                  </p>
                </div>
              </li>
              <li className="flex gap-4">
                <Icon
                  name="check_circle"
                  className="material-symbols-outlined text-primary font-bold"
                />
                <div>
                  <h5 className="font-label-md font-bold text-primary uppercase tracking-wider">
                    Screen Monitoring
                  </h5>
                  <p className="font-body-md text-on-surface-variant">
                    Teachers use professional school management software for
                    full safety.
                  </p>
                </div>
              </li>
              <li className="flex gap-4">
                <Icon
                  name="check_circle"
                  className="material-symbols-outlined text-primary font-bold"
                />
                <div>
                  <h5 className="font-label-md font-bold text-primary uppercase tracking-wider">
                    Female Teachers Available
                  </h5>
                  <p className="font-body-md text-on-surface-variant">
                    We respect family privacy and offer qualified female
                    scholars for sisters.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section-y page-x max-w-max-width mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-headline-responsive text-primary mb-4">
            Trusted by Parents and Students
          </h2>
          <div className="flex justify-center gap-1">
            <Icon
              name="star"
              className="material-symbols-outlined text-tertiary-fixed-dim"
              filled
            />
            <Icon
              name="star"
              className="material-symbols-outlined text-tertiary-fixed-dim"
              filled
            />
            <Icon
              name="star"
              className="material-symbols-outlined text-tertiary-fixed-dim"
              filled
            />
            <Icon
              name="star"
              className="material-symbols-outlined text-tertiary-fixed-dim"
              filled
            />
            <Icon
              name="star"
              className="material-symbols-outlined text-tertiary-fixed-dim"
              filled
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-gutter">
          <div className="bg-surface-container-low card-pad rounded-2xl border border-outline-variant relative">
            <Icon
              name="format_quote"
              className="material-symbols-outlined absolute top-4 right-6 text-primary/10 text-6xl"
            />
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-secondary-fixed flex items-center justify-center font-bold text-secondary">
                AM
              </div>
              <div>
                <h5 className="font-label-md font-bold text-primary">
                  Ahmed Mansoor
                </h5>
                <p className="font-caption text-on-surface-variant">
                  USA Parent
                </p>
              </div>
            </div>
            <p className="font-body-md text-on-surface-variant italic">
              "My kids actually look forward to their Quran classes. The teacher
              is so patient and uses fun interactive games that keep them
              engaged the whole hour."
            </p>
          </div>

          <div className="bg-surface-container-low card-pad rounded-2xl border border-outline-variant relative">
            <Icon
              name="format_quote"
              className="material-symbols-outlined absolute top-4 right-6 text-primary/10 text-6xl"
            />
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-primary-fixed flex items-center justify-center font-bold text-primary">
                SK
              </div>
              <div>
                <h5 className="font-label-md font-bold text-primary">
                  Sarah Khan
                </h5>
                <p className="font-caption text-on-surface-variant">
                  UK Student
                </p>
              </div>
            </div>
            <p className="font-body-md text-on-surface-variant italic">
              "Being a busy professional, I never thought I'd find time for
              Tajweed. The 24/7 scheduling at Online Quran Universe was a game
              changer for me."
            </p>
          </div>

          <div className="bg-surface-container-low card-pad rounded-2xl border border-outline-variant relative">
            <Icon
              name="format_quote"
              className="material-symbols-outlined absolute top-4 right-6 text-primary/10 text-6xl"
            />
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-full bg-tertiary-fixed flex items-center justify-center font-bold text-tertiary">
                ZM
              </div>
              <div>
                <h5 className="font-label-md font-bold text-primary">
                  Zayd Malik
                </h5>
                <p className="font-caption text-on-surface-variant">
                  Canada Parent
                </p>
              </div>
            </div>
            <p className="font-body-md text-on-surface-variant italic">
              "The progress reports are detailed and helpful. I can see exactly
              what surahs my son has completed and where he needs to focus his
              revision."
            </p>
          </div>
        </div>
      </section>

      <section className="section-y page-x bg-surface-container-highest">
        <div className="max-w-max-width mx-auto text-center bg-white p-12 md:p-24 rounded-3xl md:rounded-[3rem] shadow-2xl border border-outline-variant relative overflow-hidden">
          <div className="absolute top-0 left-0 w-32 h-32 bg-primary-fixed/30 rounded-br-full"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-tertiary-fixed/30 rounded-tl-full"></div>
          <h2 className="text-headline-responsive text-primary mb-6">
            Ready to Start Your Quran Journey?
          </h2>
          <p className="font-body-lg text-on-surface-variant mb-10 max-w-xl mx-auto">
            Join thousands of students and transform your relationship with the
            Quran today. Your first trial class is completely free.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 w-full sm:w-auto">
            <Link
              to="/contact"
              className="bg-primary text-on-primary px-10 py-4 rounded-full font-label-md font-bold shadow-lg hover:shadow-xl transition-all"
            >
              Book Free Trial Now
            </Link>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-white border-2 border-primary text-primary px-10 py-4 rounded-full font-label-md font-bold hover:bg-primary-container transition-all"
            >
              <Icon name="whatshot" className="material-symbols-outlined" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
